import React, { createContext,useState,useContext } from "react";

const TimeLeftContext = createContext();

function TimeLeftProvider({ children }) {
    const [timeLeft, setTimeLeft] = useState(null);

  return (
    <TimeLeftContext.Provider value={{ timeLeft,setTimeLeft }}>
      {children}
    </TimeLeftContext.Provider>
  );
}

const useTimeLeft = ()=>{
    return useContext(TimeLeftContext)
}

export { useTimeLeft }
export default TimeLeftProvider;
